import React from 'react';

const svgProps = { viewBox: "0 0 20 20", fill: "none", stroke: "currentColor", strokeWidth: "1.25" };

export const Ic = {
  home:   <svg {...svgProps}><path d="M3 9l7-5 7 5v8a1 1 0 0 1-1 1h-3v-6H7v6H4a1 1 0 0 1-1-1V9z"/></svg>,
  doc:    <svg {...svgProps}><path d="M4.5 2.5h7l4 4v11h-11z"/><path d="M11.5 2.5v4h4"/><path d="M7 10h6M7 13h6"/></svg>,
  euro:   <svg {...svgProps}><path d="M14.5 5.5a5 5 0 1 0 0 9"/><path d="M3.5 9h8M3.5 11.5h8"/></svg>,
  chart:  <svg {...svgProps}><path d="M3 3v14h14"/><path d="M7 13V9M11 13V6M15 13v-3"/></svg>,
  cal:    <svg {...svgProps}><rect x="3" y="4.5" width="14" height="12.5" rx="0.5"/><path d="M3 8h14M7 3v3M13 3v3"/></svg>,
  user:   <svg {...svgProps}><circle cx="10" cy="7" r="3"/><path d="M4 17c0-3 3-5 6-5s6 2 6 5"/></svg>,
  rain:   <svg {...svgProps}><path d="M6 11a3.5 3.5 0 0 1 .3-6.9A4.5 4.5 0 0 1 15 5.5a3 3 0 0 1-.8 5.9"/><path d="M7 14l-1 2.5M10 14l-1 2.5M13 14l-1 2.5"/></svg>,
  mow:    <svg {...svgProps}><rect x="2.5" y="9" width="15" height="5" rx="1"/><circle cx="6" cy="15.5" r="1.5"/><circle cx="14" cy="15.5" r="1.5"/><path d="M5 9V6h3l1-2h2l1 2h3v3"/></svg>,
  cog:    <svg {...svgProps}><circle cx="10" cy="10" r="2.5"/><path d="M10 2v2.5M10 15.5V18M2 10h2.5M15.5 10H18M4.5 4.5l1.8 1.8M13.7 13.7l1.8 1.8M15.5 4.5l-1.8 1.8M6.3 13.7l-1.8 1.8"/></svg>,
  chat:   <svg {...svgProps}><path d="M3 5.5h14v9H8l-4 3v-3H3z"/></svg>,
  plus:   <svg {...svgProps}><path d="M10 4v12M4 10h12"/></svg>,
  search: <svg {...svgProps}><circle cx="9" cy="9" r="5"/><path d="M13 13l4 4"/></svg>,
  arrowR: <svg {...svgProps}><path d="M4 10h12M12 6l4 4-4 4"/></svg>,
  arrowL: <svg {...svgProps}><path d="M16 10H4M8 6l-4 4 4 4"/></svg>,
  check:  <svg {...svgProps}><path d="M4 10.5l4 4 8-9"/></svg>,
  dot:    <svg viewBox="0 0 20 20" fill="currentColor"><circle cx="10" cy="10" r="3"/></svg>,
  menu:   <svg {...svgProps}><path d="M3 6h14M3 10h14M3 14h14"/></svg>,
  close:  <svg {...svgProps}><path d="M4 4l12 12M16 4L4 16"/></svg>,
  bulb:   <svg {...svgProps}><path d="M7 13a5 5 0 1 1 6 0c-.5.4-1 1-1 2v1H8v-1c0-1-.5-1.6-1-2z"/><path d="M8.5 18h3"/></svg>,
  logout: <svg {...svgProps}><path d="M8 4H4v12h4"/><path d="M9 10h9M15 6l3 4-3 4"/></svg>,
  filter: <svg {...svgProps}><path d="M3 5h14l-5 7v5l-4-2v-3L3 5z"/></svg>,
  download: <svg {...svgProps}><path d="M10 3v10M6 9l4 4 4-4"/><path d="M4 17h12"/></svg>,
  sun:    <svg {...svgProps}><circle cx="10" cy="10" r="3.5"/><path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.5 4.5l1.4 1.4M14.1 14.1l1.4 1.4M15.5 4.5l-1.4 1.4M5.9 14.1l-1.4 1.4"/></svg>,
  moon:   <svg {...svgProps}><path d="M16 11.5A6 6 0 1 1 8.5 4a4.5 4.5 0 0 0 7.5 7.5z"/></svg>,
};

export default Ic;
